import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

// Checkout path will look like this /checkout/subscription-checkout?plan_id=<id>
export const getSubscriptionCheckoutPath = () => {
  return urlHelper(`/checkout/subscription-checkout`);
};
